import track from "./track";
import oldCoverage from './oldCoverage';
import newCoverage from './newCoverage';
import Vue from "vue";

Vue.component('newcoverage', newCoverage)
Vue.component('oldcoverage', oldCoverage)
const coverageOptions = new Vue({
    el: '#coverage-options',

    data() {
        return {
            coverageType: 'old'
        }
    },

    methods: {
        getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
    },

    watch: {

    },
    created() {
        // const coverageCookieExists = this.getCookie('cobertura');

        // if (!coverageCookieExists){
        //     let coverage = 'old'
        //     let randomNumber = Math.random();
        //     const coverageOption = Math.round(randomNumber);
        //     if(parseInt(coverageOption) == '0') coverage = 'new';
        //     else coverage = 'old';
        //     this.setCookie('cobertura', coverage, 15)
        //     this.coverageType = coverage;
        // } else {
        //     this.coverageType = coverageCookieExists;
        // }
    },

})

